export const AIRWALLEX_PAYMENT_METHOD_ID = 7;

const AMBIGUOUS_HTTP_STATUS_IDS = [408, 429];
const LOCK_PRESERVING_HTTP_STATUS_IDS = [409];
const LOCK_PRESERVING_REASON_CODES = [
  'client_secret_age_unknown',
  'expired_client_secret_rotation_disabled',
  'expired_client_secret_gateway_unavailable',
  'expired_client_secret_cancellation_unconfirmed',
  'expired_client_secret_replacement_conflict',
];

export function isAmbiguousAirwallexFailure(error) {
  const rawResponseStatus = error && error.response
    ? error.response.status
    : null;
  const responseStatus = Number(rawResponseStatus);

  return rawResponseStatus === null
    || !Number.isFinite(responseStatus)
    || responseStatus <= 0
    || AMBIGUOUS_HTTP_STATUS_IDS.includes(responseStatus)
    || responseStatus >= 500;
}

export function isLockPreservingAirwallexFailure(error) {
  const rawResponseStatus = error && error.response
    ? error.response.status
    : null;
  const responseStatus = Number(rawResponseStatus);
  const responseData = error && error.response
    ? error.response.data
    : null;
  const reasonCode = responseData && typeof responseData === 'object'
    ? responseData.reason_code
    : null;

  return isAmbiguousAirwallexFailure(error)
    || LOCK_PRESERVING_HTTP_STATUS_IDS.includes(responseStatus)
    || LOCK_PRESERVING_REASON_CODES.includes(reasonCode);
}

function normalizedPaymentIntentId(value) {
  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim();

  return normalizedValue === '' ? null : normalizedValue;
}

export function resolveAirwallexPaymentIntentId(
  responsePaymentIntentId,
  authoritativeRecoveryPaymentIntentId = null,
  fallbackPaymentIntentId = null,
) {
  const responseId = normalizedPaymentIntentId(responsePaymentIntentId);
  const recoveryId = normalizedPaymentIntentId(
    authoritativeRecoveryPaymentIntentId,
  );

  if (responseId && recoveryId && responseId !== recoveryId) {
    throw new Error(
      'The credit card payment response could not be verified. Please refresh and try again.',
    );
  }

  return responseId
    || recoveryId
    || normalizedPaymentIntentId(fallbackPaymentIntentId);
}
